import { EnumFilter } from "@/components/data-table/components/EnumFilter";
import { PATH_PROJECT_WITH_ID } from "@/constants";
import { PROJECT_STATUS } from "@/schemas/project";
import { StoreProjectAssigneeListItem } from "@/types/storeProjectAssignees";
import PayrollTypeFilter from "@/modules/storeProjectAssignees/components/PayrollTypeFilter";
import ProjectTypeFilter from "@/modules/storeProjectAssignees/components/ProjectTypeFilter";
import { Row } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router-dom";

export const useStoreProjectAssigneeColumnOverrides = () => {
  const { t, i18n } = useTranslation();

  return useMemo(
    () => ({
      project_name: {
        id: "project_name",
        meta: {
          externalPath: (row: StoreProjectAssigneeListItem) =>
            generatePath(PATH_PROJECT_WITH_ID, { projectId: row.project_id }),
        },
      },
      project_type_name: {
        id: "project_type_name",
        meta: {
          filter: {
            component: ProjectTypeFilter,
          },
        },
      },
      payroll_type_name: {
        id: "payroll_type_name",
        meta: {
          filter: {
            component: PayrollTypeFilter,
          },
        },
      },
      project_status: {
        id: "project_status",
        cell: ({ row }: { row: Row<StoreProjectAssigneeListItem> }) =>
          i18n.t(`projectStatuses.${row.original.project_status}`),
        meta: {
          filter: {
            component: EnumFilter,
            props: {
              options: PROJECT_STATUS,
              translationKey: "projectStatuses",
            },
          },
        },
      },
      is_primary: {
        id: "is_primary",
        cell: ({ row }: { row: Row<StoreProjectAssigneeListItem> }) => (
          <>
            {t(
              `storeProjectAssignees.enum.isPrimary.${row.original.is_primary}`,
            )}
          </>
        ),
      },
    }),
    [t, i18n],
  );
};
